import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import {
  createPhase,
  createPrimary,
  deletePhase,
  deletePrimary,
  getParents,
  getProject,
} from "../../api/Primary";

const ViewPrimaryPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [countProperties, setCountProperties] = useState(0);
  const [addPhase, setAddPhase] = useState(false);
  const [loading, setLoading] = useState(false);
  const [namePhase, setNamePhase] = useState("");
  const [phaseDelete, setPhaseDelete] = useState("");
  const [deleteUnit, setDeleteUnit] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    projectsGet();
  }, []);

  const projectsGet = () => {
    getProject(params.id).then((result) => {
      setFormData(result.data.project);
      setCountProperties(result.data.countProperties);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  return (
    <div className="main-content">
      {formData === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <label htmlFor="image">Images</label>
          <div className="image-previews">
            {formData.images.map((image, imageIndex) => (
              <div key={imageIndex} className="preview-item">
                <img src={image} alt={`Preview ${imageIndex}`} />
              </div>
            ))}
          </div>

          <div
            className="choices-container"
            style={{
              display: "flex",
              width: "100%",
              gap: "15px", // Better than space-between for consistent spacing
              flexWrap: "wrap",
            }}
          >
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="logo">Developer Logo</label>
              <div style={{ position: "relative", marginTop: "16px" }}>
                {formData.developerLogoUrl && (
                  <div className="preview-item">
                    <img src={formData.developerLogoUrl} alt="logo" />
                  </div>
                )}
              </div>
            </div>
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="logo">Master plan</label>
              <div style={{ position: "relative", marginTop: "16px" }}>
                {formData.masterPlan && (
                  <div className="preview-item">
                    <img src={formData.masterPlan} alt="masterPlan" />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="Developer name">Developer name</label>
            <input type="text" value={formData.developerName} disabled />
          </div>

          <div className="form-group">
            <label htmlFor="Title">Title</label>
            <input type="text" value={formData.name} disabled />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea type="text" value={formData.description} disabled />
          </div>

          <div className="form-group">
            <label htmlFor="Location">Location</label>
            <input type="text" value={formData.areaName} disabled />
          </div>

          <div
            className="choices-container"
            style={{
              display: "flex",
              width: "100%",
              gap: "15px", // Better than space-between for consistent spacing
              flexWrap: "wrap",
            }}
          >
            {formData.startDeliveryDate && (
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="startDeliveryDate">Start Delivery Date</label>
                <input
                  type="date"
                  value={formData.startDeliveryDate.split("T")[0]}
                  disabled
                />
              </div>
            )}
            {formData.endDeliveryDate && (
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="endDeliveryDate">End Delivery Date</label>
                <input
                  type="date"
                  value={formData.endDeliveryDate.split("T")[0]}
                  disabled
                />
              </div>
            )}
          </div>

          {formData.parentCompound && (
            <div className="form-group">
              <label htmlFor="Location">Location</label>
              <input
                type="text"
                value={formData.parentCompound.name}
                disabled
              />
            </div>
          )}

          <div
            className="form-group"
            style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
          >
            <label htmlFor="developerStartingPrice">Price</label>
            <input
              type="number"
              value={formData.prices.developerStartingPrice}
              disabled
            />
          </div>

          <div className="form-group">
            <label htmlFor="locationMap">Location Map</label>
            <input type="text" value={formData.locationMap} disabled />
          </div>

          {formData.paymentPlans && formData.paymentPlans.length !== 0 && (
            <div
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "bold",
                color: "#555",
              }}
            >
              <label htmlFor="paymentPlans">Payment Plans</label>
            </div>
          )}

          {formData.paymentPlans.map((item, pIndex) => (
            <div
              key={pIndex}
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
                border: "2px solid #3498db",
                borderRadius: "4px",
                padding: "10px",
                marginBottom: "5px",
              }}
            >
              <div className="choices-container">
                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="number"
                      value={item.downPaymentPercentage}
                      disabled
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>

                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <input type="number" value={item.years} disabled />
                </div>
              </div>
            </div>
          ))}

          {formData.propertyTypes && formData.propertyTypes.length !== 0 && (
            <div style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}>
              <div
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "bold",
                  color: "#555",
                }}
              >
                <label htmlFor="Types">Types</label>
              </div>

              <div style={{ paddingBottom: "10px" }}>
                {formData.propertyTypes.map((type, index) => (
                  <div key={index}>
                    <input type="checkbox" checked disabled />
                    <label
                      htmlFor="Down payment"
                      style={{ paddingLeft: "10px" }}
                    >
                      {type.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}

          {formData.uploadFrom === "Master V" && (
            <div className="form-group">
              <label htmlFor="Type">Type</label>
              <input
                type="text"
                value={
                  formData.DataSectionId === 1 ? "Residential" : "Commercial"
                }
                disabled
              />
            </div>
          )}

          <div
            className="choices-container"
            style={{
              display: "flex",
              width: "100%",
              gap: "15px", // Better than space-between for consistent spacing
              flexWrap: "wrap",
            }}
          >
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="WhatsApp">WhatsApp number</label>
              <input type="text" value={formData.WhatsApp} disabled />
            </div>
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="Group">WhatsApp group link</label>
              <input type="text" value={formData.Group} disabled />
            </div>
          </div>

          <div
            className="choices-container"
            style={{
              display: "flex",
              width: "100%",
              gap: "15px", // Better than space-between for consistent spacing
              flexWrap: "wrap",
            }}
          >
            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="DeveloperCommission">
                Developer commission %
              </label>
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <input
                  type="text"
                  value={formData.DeveloperCommission}
                  disabled
                />
                <span
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#000",
                  }}
                >
                  %
                </span>
              </div>
            </div>

            {isSuper && (
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="Taxes">Taxes %</label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input type="text" value={formData.Taxes} disabled />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>
            )}
          </div>

          {isSuper && (
            <>
              <div
                className="choices-container"
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "15px", // Better than space-between for consistent spacing
                  flexWrap: "wrap",
                }}
              >
                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="CommissionBroker">Commission broker %</label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      value={formData.CommissionBroker}
                      disabled
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>

                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="CommissionBrokerOnSpot">
                    Commission broker onSpot %
                  </label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      value={formData.CommissionBrokerOnSpot}
                      disabled
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="choices-container"
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "15px", // Better than space-between for consistent spacing
                  flexWrap: "wrap",
                }}
              >
                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="CommissionFranchise">
                    Commission franchise %
                  </label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      value={formData.CommissionFranchise}
                      disabled
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>

                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="CommissionFranchiseOnSpot">
                    Commission franchise onSpot %
                  </label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      value={formData.CommissionFranchiseOnSpot}
                      disabled
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="BrokerBonus">Broker Bonus %</label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input type="text" value={formData.BrokerBonus} disabled />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>
            </>
          )}

          <div>
            <input
              type="checkbox"
              checked={formData.isEnable}
              disabled
              className="client-checkbox"
            />
            <label htmlFor="isEnable" style={{ paddingLeft: "10px" }}>
              Available
            </label>
          </div>

          <div>
            <input
              type="checkbox"
              checked={formData.isLaunch}
              disabled
              className="client-checkbox"
            />
            <label htmlFor="isLaunch" style={{ paddingLeft: "10px" }}>
              New Launch
            </label>
          </div>

          {formData.uploadFrom !== "Master V" && (
            <>
              {formData.phases && formData.phases.length !== 0 && (
                <div>
                  {formData.phases.map((phase, index) => (
                    <div
                      key={index}
                      className="card-card"
                      style={{ padding: "5px", margin: "10px" }}
                    >
                      <div className="card-info">
                        <div>
                          <p className="line">
                            <span className="label">Phase name:</span>{" "}
                            {phase.name}
                          </p>
                          {phaseDelete === phase.name && (
                            <div
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <p className="line">
                                Are you sure you want to delete this phase?{" "}
                              </p>
                              <div className="card-info">
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      setPhaseDelete("");
                                    }}
                                    className="action-btn accept-btn"
                                  >
                                    No
                                  </button>
                                </div>
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      setLoading(true);
                                      deletePhase({
                                        parentId: params.id,
                                        name: phaseDelete,
                                      }).then((data) => {
                                        setFormData(null);
                                        projectsGet();
                                        setLoading(false);
                                        setPhaseDelete("");
                                      });
                                    }}
                                    className="action-btn remove-btn"
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {phaseDelete === "" && (
                        <div className="card-actions">
                          <button
                            className="action-btn accept-btn"
                            onClick={() =>
                              navigate(`/properties/${phase.slug}/false`)
                            }
                          >
                            View
                          </button>
                          <button
                            className="action-btn remove-btn"
                            onClick={() => setPhaseDelete(phase.name)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {!addPhase ? (
                <div>
                  <>
                    {formData.phases && formData.phases.length !== 0 && (
                      <div
                        className="add-phase-selected"
                        onClick={() => setAddPhase(true)}
                      >
                        <label htmlFor="phases">Add Phase</label>
                      </div>
                    )}
                  </>

                  <>
                    {countProperties !== 0 && (
                      <div
                        className="add-phase-selected"
                        onClick={() =>
                          navigate(`/properties/${formData.id}/true`)
                        }
                      >
                        <label htmlFor="phases">Inventories</label>
                      </div>
                    )}
                  </>

                  <>
                    {countProperties === 0 &&
                      formData.phases &&
                      formData.phases.length === 0 && (
                        <div>
                          <div
                            className="add-phase-selected"
                            onClick={() => setAddPhase(true)}
                          >
                            <label htmlFor="phases">Add Inventory</label>
                          </div>
                          <div
                            className="add-phase-selected"
                            onClick={() =>
                              navigate(`/properties/${formData.id}/true`)
                            }
                          >
                            <label htmlFor="phases">Inventories</label>
                          </div>
                        </div>
                      )}
                  </>
                </div>
              ) : (
                <div
                  style={{
                    border: "2px solid #3498db",
                    borderRadius: "4px",
                    padding: "10px",
                    marginBottom: "5px",
                  }}
                >
                  <div className="form-group">
                    <label htmlFor="Phase name">Phase name</label>
                    <input
                      type="text"
                      id="Phase name"
                      name="Phase name"
                      value={namePhase}
                      onChange={(e) => setNamePhase(e.target.value)}
                      placeholder="Enter Phase name"
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity("Phase name is required")
                      }
                    />
                  </div>
                  {loading ? (
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <div className="spinner"></div>
                    </div>
                  ) : (
                    <div>
                      <div
                        className="cancel-phase-selected"
                        sty
                        onClick={() => {
                          setAddPhase(false);
                          setNamePhase("");
                        }}
                      >
                        <label htmlFor="phases">Cancel</label>
                      </div>
                      <div
                        className="add-phase-selected"
                        onClick={() => {
                          if (namePhase && namePhase !== "") {
                            setLoading(true);
                            createPhase({
                              parentId: params.id,
                              name: namePhase,
                            }).then((data) => {
                              setFormData(null);
                              projectsGet();
                              setAddPhase(false);
                              setNamePhase("");
                              setLoading(false);
                            });
                          }
                        }}
                      >
                        <label htmlFor="phases">Add Phase</label>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          {deleteUnit ? (
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "4px",
                padding: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p className="line">
                Are you sure you want to delete this project?{" "}
              </p>
              <div className="card-info">
                <div className="card-actions">
                  <button
                    onClick={() => {
                      setDeleteUnit(false);
                    }}
                    className="action-btn accept-btn"
                  >
                    No
                  </button>
                </div>
                <div className="card-actions">
                  <button
                    onClick={() => {
                      deletePrimary(params.id).then((resullt) => {
                        navigate(-1);
                      });
                    }}
                    className="action-btn remove-btn"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() => {
                  setDeleteUnit(true);
                }}
                className="action-btn remove-btn"
                style={{ width: "45%" }}
              >
                Delete Primary
              </button>
              <button
                onClick={() => {
                  navigate(`/update_primary/${formData._id}`);
                }}
                className={`action-btn accept-btn`}
                style={{ width: "45%" }}
              >
                Update Primary
              </button>
            </div>
          )}
          <ToastContainer />
        </div>
      )}
    </div>
  );
};

export default ViewPrimaryPage;
